module.exports = __webpack_public_path__ + "img/wx-share-mask-bg.cf0236a8.png";